import React from "react";
import { Calendar, Users, MessageSquare, Video } from "lucide-react";

interface EmptyStateProps {
  type: "events" | "commentators" | "chat" | "profile" | "search";
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  title,
  description,
  actionText,
  onAction,
  className = ""
}) => {
  const getIcon = () => {
    switch (type) {
      case "events":
        return <Calendar className="w-16 h-16 text-gray-300" />;
      case "commentators":
        return <Users className="w-16 h-16 text-gray-300" />;
      case "chat":
        return <MessageSquare className="w-16 h-16 text-gray-300" />;
      case "profile":
        return <Video className="w-16 h-16 text-gray-300" />;
      default:
        return <Calendar className="w-16 h-16 text-gray-300" />;
    }
  };

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-6 text-center ${className}`}>
      <div className="mb-6">
        {getIcon()}
      </div>

      <h3 className="text-xl font-semibold text-gray-700 mb-3">
        {title}
      </h3>

      <p className="text-gray-500 mb-6 max-w-md leading-relaxed">
        {description}
      </p>

      {actionText && onAction && (
        <button
          onClick={onAction}
          className="px-6 py-3 bg-widertalk-navy text-white rounded-lg font-medium hover:bg-widertalk-navy/90 transition-colors shadow-sm"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
